import { ALK_EVENT_TYPE, MyAppsCommand } from '@wizeoo/akm-common-lib';
import { AlkEvent } from '@wizeoo/akm-common-lib';
import { StaticFeatureEnum } from '@wizeoo/akm-common-lib';
import { UserApplicationVO } from '@wizeoo/akm-common-lib';
import { Model } from 'src/app/model/model';
import { VisionTileRenderer } from './renderers/vision-tile.renderer';
import { BuIconRenderer } from './renderers/bu-icon.renderer';
import { MultiDisplayConfig } from '@wizeoo/akm-common-lib';
import {
  WizDatasource,
  FilterComponent,
  WizNavigationManager,
  WizCommand,
  WizVgroup,
  WizLabel,
  WizEventManager, WizEvent, WizTranslationManager
} from '@wizeoo/akm-component-lib';
import { ChangeDetectionStrategy, Component, ElementRef, ViewChild } from '@angular/core';
import { BaseView } from '@wizeoo/akm-common-lib';
import { VisionIconRenderer } from './renderers/vision-icon.renderer';
import { ViewData } from '@wizeoo/akm-common-lib';
import packageJson from 'package.json';
import { UserVO } from '@wizeoo/akm-common-lib';
import { DomIconRenderer } from './renderers/dom-icon.renderer';
import { VisionVO } from '@wizeoo/akm-compute-lib';
import { RouteEngine } from 'src/app/manager/routing/route.engine';

/**
 * Le state de navigation vers la vue Fallback
 */
export type FallbackViewState = {
  
  redirectFrom: string; // la vue d'origine de la demande de navigation 
  redirectTo: string;// La vue vers laquelle l'utilisateur doit être redirigé aprés le choix de son contexte

};


/**
 * Vue de fallback. L'utilisateur attéri sur cette vue lorsque ces paramètres d'entrées dans l'application sont incohérents. (DOM, BU, VISION...)
 */
@Component({
  selector: 'fallback-view',
  templateUrl: './fallback.view.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FallbackView extends BaseView {

  @ViewChild('mainGP', { read: WizVgroup }) mainGP: WizVgroup; // zone principale
  @ViewChild('lblNothing', { read: WizLabel }) lblNothing: WizLabel; // label rien


  visionDS: WizDatasource<VisionVO> = new WizDatasource<VisionVO>([])
    .setSortFields([
      { property: 'domain', way: 'asc' },
      { property: 'businessUnitCode', way: 'asc' },
      { property: 'trsLabel', way: 'asc' },
    ])
    .setFilter(this.filterVision.bind(this))
    .build();

  /** Affichage des Apps */
  public visionMDConfig: MultiDisplayConfig<VisionVO> = {
    model: Model.getInstance(),
    datasource: this.visionDS,
    defaultMode: 'tiles',
    onSelectionChanged: this.onVisionChanged.bind(this),
    tiles: {
      enabled: true,
      renderer: VisionTileRenderer,
      itemHeight: 150,
      itemWidth: 300
    },
    grid: {
      enabled: true,
      columns: [
        {
          headerName: '$.common.domain.$',
          field: 'domain',
          width: 150,
          sortable: true,
          tooltipField: 'domain',
          cellRenderer: 'domIconRenderer'
        },
        {
          headerName: '$.common.bu.$',
          field: 'businessUnitCode',
          width: 150,
          sortable: true,
          tooltipField: 'businessUnitCode',
          cellRenderer: 'buIconRenderer'
        },
        {
          headerName: '$.common.vision.$',
          field: 'code',
          width: 220,
          sortable: true,
          tooltipField: 'code',
          cellRenderer: 'visionIconRenderer'
        },
        {
          headerName: '$.common.label.$',
          field: 'trsLabel',
          width: 150,
          sortable: true,
          tooltipField: 'trsLabel'
        },
        {
          headerName: '$.common.description.$',
          field: 'trsDescription',
          flex: 1,
          sortable: true,
          tooltipField: 'trsDescription'
        }
      ],
      renderers: { buIconRenderer: BuIconRenderer, domIconRenderer: DomIconRenderer, visionIconRenderer: VisionIconRenderer },
    },
    filter: {
      enabled: true,
      initFilter: this.initAppFilter.bind(this),
    },
  };

  appFilter: FilterComponent;

  constructor(public elementRef: ElementRef) {
    super(elementRef);
  }

  /**
   * Retourne la version de l'application depuis le package.json
   */
   get applicationVersion(): string {
    return packageJson.version;
  }

  /** State local de la vue courante */
  private get _viewState(): FallbackViewState {
    const fallState: FallbackViewState = WizNavigationManager.getViewRouteState<FallbackViewState>()
    // console.log('get source view navigation state', fallState);
    return fallState;
  }

  public wizBeforeInit(): WizCommand<any> {
    // on prend la langue du navigateur
    const lang: string =  navigator.language.split('-')[0];
    WizTranslationManager.getInstance().loadCumulatedTranslations([ // chargement des langues à minima
      lang, ViewData.defaultLocaleCode
    ]);
    Model.getInstance().currentLocaleCode = lang;
    return new MyAppsCommand(Model.getInstance()).findAllVisions(this.backFromAllVision.bind(this));
  }

  /** retour sur appel du wizInit TODO, faire l'appel dans AppInit */
  private backFromAllVision(cmd: MyAppsCommand): void {

    // Model.getInstance().visionEngine.feedVisions(cmd.visions); // TODO TODO inutile, déjà fait dans le result
    this.visionDS.setSource(cmd.visions);
    this.visionDS.refresh();

    this.mainGP.visible = this.visionDS.getWorkedSource().length > 0;
    this.lblNothing.visible = this.visionDS.getWorkedSource().length <= 0;

    // console.log('visionDS', this.visionDS)
    if (this.visionDS.getSource().length === 1) {
      this.redirect(this.visionDS.getSource()[0]);
    } else if (cmd.visions.length === 1) {
      // console.log('other BU one vision', cmd.visions[0]);
      this.redirect(cmd.visions[0]);
    }
  }

  public wizSynchronizeData() {
  }

  /**
   * Initialisation du filtre des visions
   * @param pFilter Le composant de filtre à initialiser
   * @returns
   */
  initAppFilter(pFilter: FilterComponent): FilterComponent {
    this.appFilter = pFilter;

    this.appFilter.configure(['domain', 'businessUnitCode', 'code', 'trsLabel'], null, null);
    return this.appFilter.build();
  }

  /**
   * Filtre des visions
   * @param item La vision à filtrer
   * @returns True si la vision doit être visible
   */
  filterVision(item: VisionVO): boolean {
    // Si le user n'a pas le rôle vision_access, on filtre
    if (!this.appFilter.checkVisible(item)) {
      return false;
    }
    const perimeter: UserApplicationVO = Model.getInstance().userAppEngine.newUserApp(item.domain, item.businessUnitCode, item.code);
    
    // console.log('vision ', item.domain, item.businessUnitCode, item.code);

    if (item.domain !== Model.getInstance().domainCode) {
      // console.log('vision domain filter', item);
      return false;
    }

    if (item.businessUnitCode !== Model.getInstance().businessUnitCode) {
      // console.log('vision bu filter', item);
      // return false;
    }

    if (Model.getInstance().permissionEngine.canRead(StaticFeatureEnum.VISION_ACCESS, perimeter)) {
      return true;
    }

    return false;
  }

  /**
   * Ecouteur depuis le grid
   */
  onVisionChanged(event: WizEvent) {
    // console.log('onVisionChange fallback', event);
    // juste recharger BU + vision + context
    const vision: VisionVO =this.visionDS.selectedItem;

    if(Model.getInstance().visionCode !== vision.code || Model.getInstance().businessUnitCode !== vision.businessUnitCode) {
      // console.log('fallback change bu or vision', vision.businessUnitCode, vision.code);
      if(Model.getInstance().businessUnitCode !== vision.businessUnitCode) {
        // console.log('fallback change bu', vision.businessUnitCode);
        Model.getInstance().businessUnitCode = vision.businessUnitCode;
        Model.getInstance().visionEngine.feedBuDS();
      }
      Model.getInstance().domainCode = vision.domain; // c'est le même...
      Model.getInstance().visionEngine.selectVision(vision.code);
    }
    
    this.targetLoaded();
  }

  /** l'appel est effectué... */
  private targetLoaded(): void {
       
    // console.log('fallback loaded', Model.getInstance().visionCode);
    Model.getInstance().navigationEngine.navigate(RouteEngine.NEWTAB_VIEW);
    // Dispatch des événements de modification du contexte pour que les autres composants réagissent
    setTimeout(() => {
      WizEventManager.dispatchEvent(this, new AlkEvent(ALK_EVENT_TYPE.SELECT_VISION, Model.getInstance().currentVision)); 
    }, 0);
    
  }

  /** 
   * vision unique sur fallback, sélection
   * @param vision cible
   * @param force navigation depuis la liste de la fallback, pas de contrôle d'état
   */
  private redirect(vision: VisionVO, force: boolean = false) {
    // console.log('fallback redirect', vision);

    const navigState: FallbackViewState = this._viewState; // On redirige le user vers la vue initialement demandée
    // TODO prévoir le cas user pas d'accès dashboard: prendre sa première vue dispo dans les features
    
    // si aucun onglet, générer un set
    const user: UserVO = Model.getInstance().connectedUser;
    // console.log('userctx', Model.getInstance().userContextService.getTabs());
    
    let targetView: string = RouteEngine.DASHBOARD_DATA_VIEW; // par défaut, on va sur le dashboard...
    if (!!navigState.redirectTo) {
      if(navigState?.redirectTo === RouteEngine.FALLBACK_VIEW) { // ça va pas le faire, je navigue vers moi
        // console.log('self navig', navigState);
      } else {
        // console.log('target view', navigState.redirectTo);
        targetView = navigState.redirectTo;
      }
    } else { // pas de vue cible ? dashboard
      // console.log('no state');
    }
    Model.getInstance().navigationEngine.navigate(targetView);
    
  }
}
